/**
 * Created by zhangsanfeng on 2019/11/19.
 */

export const apiPrefix = 'http://api.vdouw.com';  //测试
// export const apiPrefix = 'http://127.0.0.1:81';  //船上
export const prejuctConfig = {
  pageMiniWidth: 1360
};
export const navigation = [
  {
    name: '实时监控',
    icon: 'zsf-icon-jiankong',
    child: [
      {name: '人员实时显示', url: '/monitoring/realtime'},
      {name: '管理人员实时分布', url: '/monitoring/realtime-manage'},
      {name: '按区域人员显示', url: '/monitoring/area'},
      {name: '按安装地点显示', url: '/monitoring/install-site'},
      {name: '按船舱总段显示', url: '/monitoring/cabin'},
      {name: '设备工作状态显示', url: '/monitoring/facility-status'},
      {name: '视频追踪', url: '/monitoring/video-tracking'}
    ]
  },
  {
    name: '数据查询', icon: 'zsf-icon-chaxun',
    child: [
      {name: '轨迹查询', url: '/search/tracked'},  //历史轨迹回放
      // {name: '历史轨迹列表', url: '/search/tracked-list'},
      {name: '出入查询', url: '/search/person-in-out'},  //出入人口统计
      // { name: '进出区域信息查询', url: '/search/area-in-out' },
      // { name: '发退卡信息查询', url: '/search/card-in-out' },
      // { name: '当前位置列表', url: '/search/tracking' },
      // { name: '人员信息查询', url: '/search/person-info' },
      // { name: '人员绑定查询', url: '/search/person-bind' },
      // { name: '未解绑人员查询', url: '/search/person-binded' },
      {name: '报警查询', url: '/data/ws1-person-warning'},  //人员报警查询
      // { name: '工作超时报警', url: '/data/ws2-work-timeout' },
      // { name: '区域超员告警', url: '/data/ws3-area-full-people' },
      // { name: '禁入区域告警', url: '/data/ws4-restricted-warning' },
      // { name: '工种冲突报警', url: '/data/ws5-work-type-repeat' },
      // { name: '人员静止查询', url: '/data/ws6-person-static' },
      // { name: '基站电压低', url: '/data/ws7-station-voltage-low' },
      // { name: '基站不在线', url: '/data/ws8-station-offline' },
      // { name: '卡电压低告警', url: '/data/ws9-card-voltage-low' },
      // { name: '传感器报警', url: '/data/ws10-sensor-warning' },
    ]
  },
  {
    name: '数据报表', icon: 'zsf-icon-baobiao',
    child: [
      {name: '人员工时统计', url: '/data/person-hour'},
      {name: '日考勤', url: '/data/attendance'},
      {name: '月末统计', url: '/data/month-statistics'},
      {name: '人员报表', url: '/data/person-info'}, //人员信息报表
      // { name: '人员分布报表', url: '/data/pi1-person-distribution' },
      // { name: '轨迹报表', url: '/data/pi2-person-track' },
      // { name: '出入统计', url: '/data/pi3-in-out' },
      // { name: '人员报警记录', url: '/data/pi4-person-warning' },
      // { name: '滞留人员清单', url: '/data/pi5-person-retention' },
      // { name: '工种人数统计', url: '/data/pi6-work-type' },
      // { name: '部门人数汇总', url: '/data/pi7-department-count' },
      {name: '设备系统日志', url: '/data/device-log'},
    ]
  },
  {
    name: '设备查询', icon: 'zsf-icon-shebei',
    child: [
      {name: '分站查询', url: '/device/sub-station'},
      {name: '基站查询', url: '/device/base-station'},
      {name: '传感器查询', url: '/device/sensor'},
      {name: '声光报警器查询', url: '/device/siren'},
      {name: '喇叭查询', url: '/device/trumpet'},
    ]
  },
  {
    name: '系统设置', icon: 'zsf-icon-xitongshezhi',
    child: [
      {name: '权限设置', url: '/system/auth'},
      {name: '角色管理', url: '/system/role'},
      {name: '用户管理', url: '/system/user'},
    ]
  },
  {
    name: '参数设置', icon: 'zsf-icon-canshushezhi',
    child: [
      {name: '整船', url: '/params/ship'},
      {name: '甲板', url: '/params/deck'},
      {name: '船舱总段', url: '/params/cabin-master'},
      {name: '区域', url: '/params/area'},
      {name: '分站', url: '/params/sub-station'},
      {name: '过道', url: '/params/passage'},
      {name: '楼梯', url: '/params/stair'},
      {name: '舱室', url: '/params/cabin'},
      {name: '基站', url: '/params/base-station'},
      // {name: '区域授权', url: '/params/area-authorization'},
      // {name: '分站安装地点', url: '/params/sub-station-install'},
      {name: '工种冲突', url: '/params/work-type-conflict'},
      {name: '人员信息', url: '/params/person-info'},
      // {name: '管理人员设置', url: '/params/admin-set'},
      // {name: '基站分布', url: '/params/base-station-distribution'},
      {name: '摄像机', url: '/params/camera'},
      {name: '喇叭', url: '/params/horn'},
      {name: '传感器', url: '/params/sensor'},
      {name: '声光报警器', url: '/params/siren'},
      {name: '语音文件', url: '/params/voice'}
    ]
  },
  {
    name: '紧急告警', icon: 'zsf-icon-jinggao',
    child: [
      {name: '按人员发送', url: '/warning/person'},
      {name: '按基站发送', url: '/warning/base-station'},
      {name: '按区域发送', url: '/warning/area'},
      {name: '按甲板发送', url: '/warning/deck'},
      {name: '全船发送', type: 'allShipWarning'},
    ]
  },
  {
    name: '应急广播', icon: 'zsf-icon-guangbo',
    child: [
      // {name: '应急广播管理', url: '/radio/warning-set'},
      {name: '按区域广播', url: '/radio/area'},
      {name: '按分站广播', url: '/radio/sub-station'},
      {name: '全船广播', url: '/radio/all-ship', type: 'allShipRadio'},
      // { name: '停止广播' },
      // {name: '语音呼叫', url: '/radio/voice', type: 'voiceCalls'},
    ]
  }
];
